import React from 'react';
import { Trees, Flower2, Waves, Sprout, Leaf, Square, Layers, Fence, Grid3x3 } from 'lucide-react';
import { services } from '../utils/mockData';

const iconMap = {
  trees: Trees,
  flower: Flower2,
  waves: Waves,
  grass: Sprout,
  leaf: Leaf,
  square: Square,
  layers: Layers,
  fence: Fence,
  grid: Grid3x3
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
              Our <span className="text-green-600">Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Comprehensive landscaping solutions tailored to your needs
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div 
                  key={service.id}
                  className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-green-500"
                >
                  <div className="p-6">
                    <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-green-500 group-hover:bg-green-600 transition-colors mb-4">
                      <IconComponent className="h-8 w-8 text-black" />
                    </div>
                    <h3 className="text-xl font-bold text-black mb-3 group-hover:text-green-600 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                  <div className="h-1 bg-gradient-to-r from-green-400 to-green-600 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
